import { ModalWithForm } from '@/components/ats';
import { Box, Flex, Icon, Portal, useDisclosure } from '@chakra-ui/react';
import { ThumbsDown } from '@kula-ai/icons/outline/ThumbsDown';
import { ThumbsDown as ThumbsDownSolid } from '@kula-ai/icons/solid/ThumbsDown';
import { ThumbsUp } from '@kula-ai/icons/outline/ThumbsUp';
import { ThumbsUp as ThumbsUpSolid } from '@kula-ai/icons/solid/ThumbsUp';

import { useState, useRef } from 'react';
import { FormBuilder } from '@/components/formBuilder';
import { useKFlags } from '@/hooks/use-k-flags';

export const FeedbackForm = ({
  onFeedbackSubmit,
  onModalStateChange = (_isOpen) => {},
  trace_id,
  feedbackable_id,
  ats_job_id,
  is_test_run = false,
  headerText = 'Help us improve AI scoring',
  containerStyles = {},
  iconProps = {},
  thumbsUpMeta = {},
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { feJobTeammates } = useKFlags();
  const resolvedHeaderText =
    headerText === 'Help us improve AI scoring' && feJobTeammates
      ? 'Help us improve the Scoring agent'
      : headerText;
  const formRef = useRef(null);

  // 0 bad, 1 for good
  const [rating, setRating] = useState(1);
  const [isUpHover, setIsUpHover] = useState(false);
  const [isDownHover, setIsDownHover] = useState(false);

  const handleClose = () => {
    onClose();
    onModalStateChange(false);
  };

  return (
    <>
      <Flex gap="6px" alignItems="center" {...containerStyles}>
        <Box
          cursor="pointer"
          onMouseEnter={() => setIsUpHover(true)}
          onMouseLeave={() => setIsUpHover(false)}
          onClick={() => {
            onFeedbackSubmit({
              feedback: 'Good',
              rating: 1,
              trace_id,
              feedbackable_id,
              ats_job_id,
              is_test_run,
              meta: thumbsUpMeta,
            });
          }}
        >
          <Icon as={isUpHover ? ThumbsUpSolid : ThumbsUp} {...iconProps} />
        </Box>
        <Box
          cursor="pointer"
          onMouseEnter={() => setIsDownHover(true)}
          onMouseLeave={() => setIsDownHover(false)}
          onClick={() => {
            setRating(0);
            onOpen();
            onModalStateChange(true);
          }}
        >
          <Icon
            as={isDownHover ? ThumbsDownSolid : ThumbsDown}
            {...iconProps}
          />
        </Box>
      </Flex>
      {isOpen && (
        <Portal containerRef={{ current: document.body }}>
          <ModalWithForm
            headerText={resolvedHeaderText}
            modalHeaderProps={{
              pb: 0,
            }}
            isOpen={isOpen}
            onClose={handleClose}
            onCancel={(e) => {
              e?.preventDefault();
              e?.stopPropagation();
              onClose();
              onModalStateChange(false);
            }}
            withForm={false}
            primaryCtaText="Send"
            handleSubmit={() => {
              const feedback = formRef.current?.values?.feedback || '';
              if (!feedback) {
                return;
              }
              onFeedbackSubmit(
                {
                  feedback,
                  rating,
                  trace_id,
                  feedbackable_id,
                  ats_job_id,
                  is_test_run,
                },
                () => {
                  onClose();
                  onModalStateChange(false);
                }
              );
            }}
          >
            <FormBuilder
              formRef={formRef}
              config={[
                {
                  type: 'textArea',
                  name: 'feedback',
                  placeholder: 'Please share your feedback',
                  style: {
                    row: 8,
                  },
                  isRequired: true,
                  errorMessage: 'Feedback is required',
                },
              ]}
              initialValues={{ feedback: '' }}
            />
          </ModalWithForm>
        </Portal>
      )}
    </>
  );
};
